import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import BeyondBillingOverview from 'components/practice/BeyondBilling/Overview/Overview';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const BeyondBilling = withLazyFallback(() => import('components/practice/BeyondBilling'));
const CMS1500 = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/CMS1500/CMS1500')
);
const Eob = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/ERA&EOB/EOB/Eob')
);
const Era = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/ERA&EOB/ERA/Era')
);
const ViewEra = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/ERA&EOB/ERA/components/ViewEra/ViewEra')
);
const NewClaims = withLazyFallback(
  () => import('components/practice/BeyondBilling/Claims/NewClaims')
);
const DynamicAR = withLazyFallback(
  () => import('components/practice/BeyondBilling/DynamicAR/DynamicAR')
);
const DynamicInvoices = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/DynamicInvoices')
);
const ElectronicInvoicing = withLazyFallback(
  () => import('components/practice/BeyondBilling/ElectronicInvoicing/ElectronicInvoicing')
);
const ViewInternalInvoice = withLazyFallback(
  () =>
    import('components/practice/BeyondBilling/ElectronicInvoicing/components/ViewInternalInvoice')
);
const IncomeIQueue = withLazyFallback(
  () => import('components/practice/BeyondBilling/IncomeIQueue/IncomeIQueue')
);
const PatientLedger = withLazyFallback(
  () => import('components/practice/BeyondBilling/PatientLedger/PatientLedger')
);
const Payments = withLazyFallback(
  () => import('components/practice/BeyondBilling/Payments/Payments')
);
const BeyondBillingReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/BeyondBillingReports')
);
const CustomReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/CustomReports/CustomReports')
);
const FavoriteReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/FavoriteReports/FavoriteReports')
);
const StandardReports = withLazyFallback(
  () => import('components/practice/BeyondBilling/Reports/pages/StandardReports/StandardReports')
);
const Superbills = withLazyFallback(
  () => import('components/practice/BeyondBilling/Superbill/Superbills')
);

const PRACTICE_BEYOND_BILLING = [
  {
    path: 'beyond-billing',
    element: <BeyondBilling />,
    children: [
      { path: '', element: <BeyondBillingOverview /> },
      { path: 'income-i-queue', element: <IncomeIQueue /> },
      {
        path: 'payments',
        element: <Payments />,
        children: [{ path: 'era/:id', element: <ViewEra /> }]
      },
      { path: 'patient-ledger', element: <PatientLedger name="patient_ledger" /> },
      {
        path: 'dynamic-ar',
        element: <DynamicAR />,
        children: [{ path: ':type', element: <DynamicAR /> }]
      },
      {
        path: 'era',
        element: <Era />,
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'eob',
        element: <Eob />,
        children: [{ path: ':id', element: <ViewEra /> }]
      },
      {
        path: 'claims',
        element: <NewClaims />,
        children: [
          { path: ':id', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'superbills',
        element: <Superbills />,
        children: [
          { path: 'claim/:claimId', element: <CMS1500 /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'electronic-invoicing',
        element: <ElectronicInvoicing />,
        children: [
          {
            path: '',
            element: <DynamicInvoices />,
            children: [{ path: ':invoiceId', element: <ViewInternalInvoice fromRoute /> }]
          },
          { path: '*', element: <NotFound /> }
        ]
      },
      {
        path: 'reports',
        element: <BeyondBillingReports />,
        children: [
          // { path: 'r-overview', element: <OverviewReports /> },
          { path: 'standard', element: <StandardReports /> },
          { path: 'favorite', element: <FavoriteReports /> },
          { path: 'custom', element: <CustomReports /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_BEYOND_BILLING;
